import type { LabTurn, LabTurnDiff } from "@/lib/labModel";
import type { LabRunModel } from "@/lib/labRunModel";
import { Badge } from "@/ui/Badge";

import { CriteriaTable, NOTHING, Section } from "./LabTurnSummary";

/** Criteria tab: every criterion evaluated at this turn, with the version of the source that defined it. */
export function LabCriteriaTab({
  turn,
  diff = null,
}: {
  projectId: string;
  previewRunRef: string;
  turn: LabTurn;
  model: LabRunModel;
  onSelectTurn: (turn: number) => void;
  diff?: LabTurnDiff | null;
}) {
  const passed = turn.criteria.filter((c) => c.detail.passed).length;
  const failed = turn.criteria.length - passed;
  return (
    <Section title="Criteria" differs={diff?.threshold === true}>
      {turn.criteria.length === 0 ? (
        NOTHING
      ) : (
        <>
          <p className="flex flex-wrap items-center gap-2 text-sm">
            <Badge tone="success">{passed} met</Badge>
            <Badge tone={failed > 0 ? "warning" : "outline"}>
              {failed} not met
            </Badge>
          </p>
          <CriteriaTable criteria={turn.criteria} showSourceVersion />
        </>
      )}
    </Section>
  );
}
